module.exports = __webpack_public_path__ + "img/geodir-logo.c365f4eb.svg";